import {
  getLastReadTimestampApi,
  getNotifcationsApi,
  readNotifcationsApi,
  setLastReadTimestampApi,
} from "../../apis/notification.api";
import { actions, NOTIFICATION_TYPE } from "../../utils/constants";
import { callApiAction } from "./commonAction";

const redirectTo = (type, id) => {
  switch (type) {
    case NOTIFICATION_TYPE.general:
      return null;
    case NOTIFICATION_TYPE.leave:
      return `/calendar/leave/id/${id}`;
    case NOTIFICATION_TYPE.coff:
      return `/calendar/c-off/id/${id}`;
    case NOTIFICATION_TYPE.task:
      return `/tasks/detail/${id}`;
    case NOTIFICATION_TYPE.reimbursement:
      return `/reimbursement/get/${id}`;
    case NOTIFICATION_TYPE.wfh:
      return `/calendar/Pending/`;
    case NOTIFICATION_TYPE.announcements:
      return `/dashboard/`;
    default:
      return null;
  }
};

export const fetchNotificationAction = () => {
  return async (dispatch) => {
    const lastReadTimestamp = await getLastReadTimestampApi();
    const parsedLastReadTimestamp = new Date(lastReadTimestamp);
    const hasValidLastReadTimestamp = !Number.isNaN(
      parsedLastReadTimestamp.getTime(),
    );

    dispatch(
      callApiAction(
        async () => await getNotifcationsApi(),
        (response) => {
          const notifications = Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : [];

          const parsedNotifications = notifications.map((notification) => ({
            ...notification,
            redirect: redirectTo(
              notification.notificationType,
              notification.contentId,
            ),
          }));

          const newNotification = parsedNotifications.reduce(
            (count, notification) => {
              if (typeof notification.isRead === "boolean") {
                return notification.isRead ? count : count + 1;
              }

              const createdAt = new Date(notification.createdAt);
              const hasValidCreatedAt = !Number.isNaN(createdAt.getTime());

              if (
                hasValidLastReadTimestamp &&
                hasValidCreatedAt &&
                createdAt > parsedLastReadTimestamp
              ) {
                return count + 1;
              }

              // If read metadata is unavailable, default to showing as unread.
              if (!hasValidLastReadTimestamp) {
                return count + 1;
              }

              return count;
            },
            0,
          );

          dispatch({
            type: actions.SET_NOTIFICATION_DATA,
            new: newNotification,
            data: parsedNotifications,
          });
        },
        (err) => {
          console.error(err);
        },
      ),
    );
  };
};

export const readNotificationAction = () => {
  return async (dispatch, getState) => {
    const notifications = getState().notifications?.data;

    if (notifications && notifications.length > 0) {
      const lastReadTimestamp = notifications[0].createdAt;
      await setLastReadTimestampApi(lastReadTimestamp);
      dispatch(
        callApiAction(
          async () =>
            await readNotifcationsApi({
              ids: notifications.map((notification) => notification._id),
            }),
          (response) => {},
          (err) => {
            console.error(err);
          },
        ),
      );
    }

    dispatch({ type: actions.NOTIFICATION_READ });
  };
};

export const readIndividualNotificationAction = (notificationId) => {
  return async (dispatch, getState) => {
    return dispatch(
      callApiAction(
        async () => await readNotifcationsApi({ id: [notificationId] }),
        (response) => {},
        (err) => {
          console.error(err);
        },
      ),
    );
  };
};
